import { render } from "./page-demo-completed.vue?vue&type=template&id=ea50c1f4&scoped=true"
import script from "./page-demo-completed.vue?vue&type=script&lang=js"
export * from "./page-demo-completed.vue?vue&type=script&lang=js"

import "./page-demo-completed.vue?vue&type=style&index=0&id=ea50c1f4&lang=stylus&scoped=true"

import exportComponent from "/var/www/docker/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-ea50c1f4"],['__file',"src/components/notepad/pages/page-demo-completed.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "ea50c1f4"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('ea50c1f4', __exports__)) {
    api.reload('ea50c1f4', __exports__)
  }
  
  module.hot.accept("./page-demo-completed.vue?vue&type=template&id=ea50c1f4&scoped=true", () => {
    api.rerender('ea50c1f4', render)
  })

}


export default __exports__